export default __webpack_public_path__ + "static/media/panteras_group.5163a777.jpg";